import {Pipe, PipeTransform} from '@angular/core';

export type IntegrationScopeValue =
  | 'standalone'
  | 'pooled'
  | 'provider'
  | boolean
  | null
  | undefined;

@Pipe({
  name: 'integrationScope',
  standalone: false,
})
export class IntegrationScopePipe implements PipeTransform {
  transform(value: IntegrationScopeValue): string {
    if (value === true || value === 'standalone' || value === 'provider') {
      return 'enums.integrationScope.standalone';
    }

    if (value === false || value === 'pooled') {
      return 'enums.integrationScope.pooled';
    }

    return 'common.unknown';
  }
}
